import { useState, useEffect } from 'react';
import SplitPaymentModal from "../../bankAccount/card/splitPaymentModal";
import GenericDropdown from '../../generic/genericDropdown';
import MarkNoLongerPendingModal from "./markNoLongerPendingModal";


function TransactionsRowDropdown(props) {
	const [showSplitPaymentModal, setShowSplitPaymentModal] = useState(false);
	const [showMarkNoLongerPendingModal, setShowMarkNoLongerPendingModal] = useState(false);
	const [dropdownItems, setDropdownItems] = useState([]);

	useEffect(() => {
		let newDropdownItems = [];

		if (!props.pending) {
			newDropdownItems.push(
				<div
					onClick={() => setShowSplitPaymentModal(true)}
					style={{
						color: "black",
						border: "0px",
						padding: "5px 0px",
						cursor: "pointer",
					}}
				>
					Split
				</div>
			);
		}

		if (props.pending && props.selectedTransaction?.is_manual === true) {
			newDropdownItems.push(
				<div
					onClick={() => setShowMarkNoLongerPendingModal(true)}
					style={{
						color: "black",
						border: "0px",
						padding: "5px 0px",
						cursor: "pointer",
					}}
				>
					No longer pending
				</div>
			);
		}

		setDropdownItems(newDropdownItems);
	}, [props.pending, props.selectedTransaction?.is_manual]);

	return (
		<>
			<GenericDropdown dropdownItems={dropdownItems} />
			{showSplitPaymentModal && (
				<SplitPaymentModal
					selectedTransaction={props.selectedTransaction}
					showSplitPaymentModal={showSplitPaymentModal}
					closeSplitTransactionModal={() => setShowSplitPaymentModal(false)}
					updateCompletedTransactions={props.updateSplitTransactions}
					bankAccountId={props.selectedTransaction.info.bank_account_id}
				/>
			)}

			{/* Render MarkNoLongerPendingModal only when showMarkNoLongerPendingModal is true */}
			{showMarkNoLongerPendingModal && (
				<MarkNoLongerPendingModal
					selectedTransaction={props.selectedTransaction}
					showMarkNoLongerPendingModal={showMarkNoLongerPendingModal}
					setShowMarkNoLongerPendingModal={setShowMarkNoLongerPendingModal}
				/>
			)}
		</>
	)
}

export default TransactionsRowDropdown